export const devicesSelector = (state) => state.devices;
